import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './EndSessionCommentary.css';
import Pagination from '../../../CommonUI/Pagination/Pagination';
import { Modal } from "react-bootstrap";
import renderHTML from 'react-render-html';
import NewsOption from "../../NewsOption/NewsOption";
import { Vortex } from 'react-loader-spinner';
import CallTrackApi from "../../../Activity_Track/CallTrackApi";
let companyInformation;

function EndSessionCommentary() {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [data, setData] = useState([]);
    const [filteredNewsData, setFilteredNewsData] = useState([]);
    const [companyInfo, setCompanyInfo] = useState([]);


    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);
        const getUrl = BaseURL + "News";

        fetch(`${getUrl}/1/6/-/100`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                companyInformation = data.data;
                //console.log(data.data)
                setCompanyInfo(companyInformation);
                //console.log("data", companyInformation);
                // console.log(getData, "getData")
                setloadingshow(false);
            })
            .catch((error) => {
            });


    }, []);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);

    const routeChange = (event) => {
        const fetchId = event.currentTarget.getAttribute('data-id');
        const fetchHead = event.currentTarget.getAttribute('data-head');
        window.open("/Detail-News/" + fetchId + "/" + fetchHead.replace(/ /g, '-').replace('&', 'and').replace('/', 'slash').replace('?', 'questionMark').replace('=', 'isEqualsTo').replace(':', 'colon').replace('%', 'Percent'), '_blank');
    };
    CallTrackApi("End Session Commentary",window.location.href);

    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>End-Session Commentary</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='end-loser-sc'>
                            <div className='end-header'>
                                <h2><span>End-Session Commentary</span></h2>
                            </div>
                            <NewsOption optionNews="End-Session Commentary" />
                            {/* <hr className="endhr"></hr> */}
                            <div className='end-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>

                                            <th className='text-left' >Date</th>
                                            <th className='Endtxt' >Time</th>
                                            <th className='text-left'>Heading</th>

                                        </tr>

                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ Date, Time, Heading, Sno }) => (
                                                <tr>
                                                    <td className="text-left"> {(Date != null) ? Date.split('T')[0] : 0}</td>
                                                    <td className="text-left"> {Time}</td>
                                                    <td className="newhead"><h6 onClick={routeChange} data-head={Heading} data-id={Sno}>{Heading}</h6> </td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                    <Vortex
                                        visible={true}
                                        height="80"
                                        width="80"
                                        ariaLabel="vortex-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="vortex-wrapper"
                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                    />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                }


                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer compNews"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default EndSessionCommentary;